const getTypeByLang = (type, t) => {
    switch (type) {
        case 'Kiosk':
            return t("Console.Kiosk.KioskTitle");
        case 'Home':
            return t("Unplugged.DeliveryType.HomeTitle");
        case 'Work':
            return t("Unplugged.DeliveryType.WorkTitle");
        case 'Courier':
            return t("Assign.Courier.Courier");
        case 'Curb Side':
            return t("Console.Curbside.CurbsideTitle");
        case 'Counter':
            return t("Console.Counter.CounterTitle");
        case 'Bedside':
            return t("Console.Bedside.BedsideTitle");
        case 'Other':
            return t("Report.Stocked.ManualOverride.Other");
        case 'Mail Order':
            return t("Login.MailOrderImageTitle");
        default:
            break;
    }
}

export default getTypeByLang



// WEBPACK FOOTER //
// ./src/components/common/typeByLang.js